module.exports = __webpack_public_path__ + "static/media/chip.5f27e649.svg";